import type { Transaction } from '@api/hooks/types/getTransactions';
import type { TFunction } from 'i18next';

import type { CardConfig } from '../types';

export const getSwiftAdditionalDetailsCard = (
	operation: Transaction,
	t: TFunction,
	hasAddressAligned?: boolean,
): CardConfig => ({
	title: t('additionalDetails.title'),
	groups: [
		{
			title: t('additionalDetails.beneficiaryAddress'),
			fields: [
				{
					title: t('common.country'),
					content: operation?.beneficiary?.address?.country,
				},
				{
					title: t('common.city'),
					content: operation?.beneficiary?.address?.town,
				},
				...(hasAddressAligned
					? [
							{
								title: t('common.state'),
								content: operation?.beneficiary?.address?.country_sub_division,
							},
							{
								title: t('common.street'),
								content: operation?.beneficiary?.address?.street_name,
							},
							{
								title: t('common.buildingName'),
								content: operation?.beneficiary?.address?.building_name,
							},
						]
					: [
							{
								title: t('common.street'),
								content: operation?.beneficiary?.address?.line,
							},
						]),
				{
					title: t('common.buildingNumber'),
					content: operation?.beneficiary?.address?.building_number,
				},
				{
					title: t('common.postalCode'),
					content: operation?.beneficiary?.address?.postal_code,
				},
			],
		},
		{
			title: t('additionalDetails.beneficiaryBank'),
			fields: [
				{
					title: t('additionalDetails.bicCode'),
					content: operation?.beneficiary?.bank?.bic,
				},
				{
					title: t('additionalDetails.bankName'),
					content: operation?.beneficiary?.bank?.name,
				},
				{
					title: t('common.country'),
					content: operation?.beneficiary?.bank?.address?.country,
				},
				{
					title: t('common.city'),
					content: operation?.beneficiary?.bank?.address?.town,
				},
				...(hasAddressAligned
					? [
							{
								title: t('common.state'),
								content: operation?.beneficiary?.bank?.address?.country_sub_division,
							},
							{
								title: t('common.street'),
								content: operation?.beneficiary?.bank?.address?.street_name,
							},
							{
								title: t('common.buildingName'),
								content: operation?.beneficiary?.bank?.address?.building_name,
							},
						]
					: [
							{
								title: t('common.street'),
								content: operation?.beneficiary?.bank?.address?.line,
							},
						]),
				{
					title: t('common.buildingNumber'),
					content: operation?.beneficiary?.bank?.address?.building_number,
				},
				{
					title: t('common.postalCode'),
					content: operation?.beneficiary?.bank?.address?.postal_code,
				},
			],
		},
		{
			title: t('additionalDetails.correspondentBank'),
			fields: [
				{
					title: t('additionalDetails.bicCode'),
					content: operation?.correspondent?.bic,
				},
				{
					title: t('additionalDetails.bankName'),
					content: operation?.correspondent?.name,
				},
				{
					title: t('common.country'),
					content: operation?.correspondent?.address?.country,
				},
				{
					title: t('common.city'),
					content: operation?.correspondent?.address?.town,
				},
				...(hasAddressAligned
					? [
							{
								title: t('common.state'),
								content: operation?.correspondent?.address?.country_sub_division,
							},
							{
								title: t('common.street'),
								content: operation?.correspondent?.address?.street_name,
							},
							{
								title: t('common.buildingName'),
								content: operation?.correspondent?.address?.building_name,
							},
						]
					: [
							{
								title: t('common.street'),
								content: operation?.correspondent?.address?.line,
							},
						]),
				{
					title: t('common.buildingNumber'),
					content: operation?.correspondent?.address?.building_number,
				},
				{
					title: t('common.postalCode'),
					content: operation?.correspondent?.address?.postal_code,
				},
			],
		},
	],
});
